import { render } from "./MenuFooter.vue?vue&type=template&id=66bfe6d3"
import script from "./MenuFooter.vue?vue&type=script&lang=js"
export * from "./MenuFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__